import {
  getAsyncWithToken,
  postAsyncWithToken,
  postAsyncWithTokenFormData,
} from "./requestWithToken";

const campaignApi = process.env.REACT_APP_SEO_SERVICE_API;
const graphqlQueryUrl = `${campaignApi}/seo/campaigns/graphql-query`;

export async function createCampaignOptimize(data) {
  const url = `${campaignApi}/seo/campaigns/create`;
  return postAsyncWithToken(url, data);
}

export async function addTargetCampaignOptimize(data) {
  const url = `${campaignApi}/seo/campaigns/add-target`;
  return postAsyncWithToken(url, data);
}

export async function getCampaignOptimize(data) {
  const url = `${campaignApi}/seo/campaigns/list`;
  return getAsyncWithToken(url, data);
}

export async function getCampaignDetail(campaignId) {
  const url = `${campaignApi}/seo/campaigns/detail?campaignId=${campaignId}`;
  return getAsyncWithToken(url);
}

export async function getCampaignInProcess(campaignId) {
  const url = `${campaignApi}/seo/campaigns/in-process?campaignId=${campaignId}`;
  return getAsyncWithToken(url);
}

export async function deleteCampaign(campaignId) {
  const url = `${campaignApi}/seo/campaigns/delete?campaignId=${campaignId}`;
  return getAsyncWithToken(url);
}

export async function restartCampaign(campaignId) {
  const url = `${campaignApi}/seo/campaigns/restart?campaignId=${campaignId}`;
  return getAsyncWithToken(url);
}

export async function revertCampaign(campaignId) {
  const url = `${campaignApi}/seo/campaigns/set-restore?campaignId=${campaignId}`;
  return getAsyncWithToken(url);
}

export async function registerRecurringCharge(data) {
  const payload = {
    price_name: data || "BASIC",
    bundle: false,
    year_charge: false,
  };
  const url = `${campaignApi}/seo/campaigns/register-recurring-charge`;
  return postAsyncWithTokenFormData(url, payload);
}

export async function getCampaignListTarget(data) {
  const { campaignId, page, limit, search } = data;
  const url = `${campaignApi}/seo/campaigns/list-target?campaignId=${campaignId}&page=${page}&limit=${limit}&search=${search}`;
  return getAsyncWithToken(url, data);
}

export async function getCampaignTargetListImage(data) {
  const { targetId, page, limit, search } = data;
  const url = `${campaignApi}/seo/campaigns/list-image?targetId=${targetId}&page=${page}&limit=${limit}&search=${search}`;
  return getAsyncWithToken(url, data);
}

export async function getReportByShop() {
  const url = `${campaignApi}/seo/campaigns/report`;
  return getAsyncWithToken(url);
}

export async function getPlanByShop() {
  const url = `${campaignApi}/seo/campaigns/plan`;
  return getAsyncWithToken(url);
}

export async function getProductByCollectionIdRes(first, collectionId, after) {
  const graphql_query = `query collectionProductList{
  collection(id: "gid://shopify/Collection/${collectionId}") {
    productsCount {
      count
    }
    products(first: ${first}, after: ${(after && `"${after}"`) || null}) {
      nodes {
        id
        featuredMedia {
          preview {
            image {
              url
            }
          }
        }
        handle
        title
      }
      pageInfo {
        hasNextPage
        endCursor
        hasPreviousPage
        startCursor
      }
    }
  }
}`;
  try {
    const response = await postAsyncWithTokenFormData(graphqlQueryUrl, {
      graphql_query,
    });
    return response.data;
  } catch (error) {
    return null;
  }
}

export async function getCollectionsRes(first, searchName, after) {
  const graphql_query = `query CollectionList {
  collections(first: ${first}, query: "${searchName}", after: ${(after && `"${after}"`) || null}) {
    nodes {
      id
      handle
      title
      image {
        id
        url
      }
      productsCount {
        count
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
      startCursor
    }
  }
}`;
  try {
    const response = await postAsyncWithTokenFormData(graphqlQueryUrl, {
      graphql_query,
    });
    return response.data;
  } catch (error) {
    return null;
  }
}

export async function getProductsRes(first, searchName, after) {
  const graphql_query = `query ProductList {
  products(first: ${first}, query: "${searchName}", after: ${(after && `"${after}"`) || null}) {
    nodes {
      id
      handle
      title
      featuredMedia {
        preview {
          image {
            url
          }
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
      startCursor
    }
  }
}`;
  try {
    const response = await postAsyncWithTokenFormData(graphqlQueryUrl, {
      graphql_query,
    });
    return response.data;
  } catch (error) {
    return null;
  }
}

export async function getArticlesRes(first, query, after) {
  const graphql_query = `query articleList {
  articles(first: ${first}, query: "${query}", after: ${(after && `"${after}"`) || null}) {
    nodes {
      id
      handle
      title
      image {
        url
      }
      blog{
        id
        handle
        title
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
      startCursor
    }
  }
}`;
  try {
    const response = await postAsyncWithTokenFormData(graphqlQueryUrl, {
      graphql_query,
    });
    return response.data;
  } catch (error) {
    return null;
  }
}
